import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { LeadService } from '../lead.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { LeadForm } from '../model/model.lead';

@Component({
  selector: 'app-mapleadfeld',
  templateUrl: './mapleadfeld.component.html',
  styleUrls: ['./mapleadfeld.component.css']
})
export class MapleadfeldComponent implements OnInit {

  public lastUploadid: number;
  state: boolean;
  submitstate: boolean = false;
  procesedState: boolean;
  form: FormGroup;
  leadForm: LeadForm;

  mappeddata: any = {
    RawHeader: [],
    Dialers: []
  }
  mapdata: any = {
    RawHeader: [],
    Dialers: []
  }
  ledsColumn: any = {
    RawHeader: [],
    Dialers: []
  }
  dL: any[] = []

  leadHeader = [];
  public alltemplate: any = [];
  public _fileheader = [];
  public template_id: number = -1;
  public template_name: string = "Default Template";
  nleadfield: any;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public dialogRef: MatDialogRef<MapleadfeldComponent>, protected router: Router, protected msg: MatSnackBar, protected fb: FormBuilder, protected leadservice: LeadService) { }

  ngOnInit() {
    console.log("Headers Data::\n", this.data)
    console.log("lead filed data:::::", this.data.leadfield)
    console.log("mapdatahedaer", this.mapdata.RawHeader)
    console.log("rdialer", this.data.dialer_type)

    // @fetching first row from previous mapped headers
    this.alltemplate = this.data.maphead
    if (Array.isArray(this.data.maphead) && this.data.maphead.length > 0) {
      this.mapdata = this.data.maphead[0].field_map
      this.template_id = this.data.maphead[0].id
      this.template_name = this.data.maphead[0].name
    }
    this._fileheader = JSON.parse(this.data.fileheader)

    // @making reactive form of header mapping
    if (this.data) {
      this.leadForm = new LeadForm(null);
      this.form = this.leadForm.makeform(this.fb);
      console.log(this.leadForm);
    }

    // It will filter lead field's dialer
    // with agent' selected dialers
    let nD: any[] = []
    this.data.leadfield.Dialers.forEach((ele: any) => {
      if (this.data.ActDialers.includes(ele.id_dialer))
        nD.push(ele)
    })
    this.data.leadfield.Dialers = nD


    // @dialer mapping
    if (sessionStorage.getItem("allcampaign"))
      this.dL = JSON.parse(sessionStorage.getItem("allcampaign"))

    // @It will load saved template into field's columns
    this.ldTmp()

    console.log("fileheader data:::", this._fileheader)
    Object.entries(this._fileheader).forEach(([key, value]) => {
      console.log(key, value)
      this.leadHeader.push({
        'cols': value,
        'indcol': parseInt(key) + 1
      })
    })

    console.log("rawheader", this.leadHeader)
  }


  ldTmp(): void {
    console.log("leadfield  header", this.data.leadfield.RawHeader)
    console.log("leadfield  dialer", this.data.leadfield.Dialers)
    // @Sepating fields with form fields and mapped header
    // On Raw Header Fields
    for (let x of this.data.leadfield.RawHeader) {
      let I1: any = this.mapdata.RawHeader.findIndex((ele: any, i: any) => {
        return ele.crmfields == x.fields
      })
      // let l1: number = this.mapdata.RawHeader.length
      if (this.data.dialer_type == 1) {
        if (I1 > -1) {
          let cH: any = (this._fileheader.indexOf(this.mapdata.RawHeader[I1].label)) + 1
          
          // pushing data for lead columns
          if (x.fields == "spouse_full_name" || x.fields == "spouse_age" || x.fields == "spouse_birth_date" || x.fields == "spouse_height" || x.fields == "spouse_weight" || x.fields == "spouse_occupation") {
            console.log("in continue block::", x.fields)
            continue
          }
          else {
            this.ledsColumn.RawHeader.push({
              fields: x.fields,
              label: x.label,
              headermap: cH
            })
          }


          // pushing data for mapped data with header
          this.mappeddata.RawHeader.push({
            crmfields: this.mapdata.RawHeader[I1].crmfields,
            headermap: cH,
            label: this.mapdata.RawHeader[I1].label
          })
        }
        else {
          if (x.fields == "spouse_full_name" || x.fields == "spouse_age" || x.fields == "spouse_birth_date" || x.fields == "spouse_height" || x.fields == "spouse_weight" || x.fields == "spouse_occupation") {
            console.log("in continue block::", x.fields)
            continue
          }
          // pushing data for lead columns
          else {
            this.ledsColumn.RawHeader.push({
              fields: x.fields,
              label: x.label,
              headermap: 0
            })
          }
        }
        console.log("total raw header::", this.ledsColumn.RawHeader)
      }
      else {
        console.log("I1:::",I1)
        console.log("_fileheader",this._fileheader)
        if (I1 > -1) {
          let cH: any = (this._fileheader.indexOf(this.mapdata.RawHeader[I1].label)) + 1
          console.log("CH:::",cH)
          // pushing data for lead columns

          this.ledsColumn.RawHeader.push({
            fields: x.fields,
            label: x.label,
            headermap: cH
          })

          // pushing data for mapped data with header
          this.mappeddata.RawHeader.push({
            crmfields: this.mapdata.RawHeader[I1].crmfields,
            headermap: cH,
            label: this.mapdata.RawHeader[I1].label
          })
        }
        else {
          // pushing data for lead columns
          this.ledsColumn.RawHeader.push({
            fields: x.fields,
            label: x.label,
            headermap: 0
          })
        }
      }
    }
    console.log("this.ledsColumn::1", this.ledsColumn)
    console.log("this.mappeddata::1", this.mappeddata)

    // @Sepating fields with form fields and mapped header
    // On Dialer-Wise Header Fields
    for (let x1 of this.data.leadfield.Dialers) {
      // for each dialer
      let lC: any[] = []
      let mD: any[] = []
      let iD: any = this.dL.findIndex((ele: any) => {
        return ele.id == x1.id_dialer
      })
      let dT: string = this.dL[iD].name
      for (let x of x1.header) {

        // It will find the Index position of each dialer
        let I1: any = this.mapdata.Dialers.findIndex((ele: any, i: any) => {
          return ele.id_dialer == x1.id_dialer
        })
        if (I1 > -1) {
          let I2: any = this.mapdata.Dialers[I1].header.findIndex((ele: any, i: any) => {
            return ele.crmfields == x.fields
          })
          // let l1: number = this.mapdata.Dialers[I1].header.length
          if (I2 > -1) {
            let cH: any = (this._fileheader.indexOf(this.mapdata.Dialers[I1].header[I2].label)) + 1

            // pushing data for lead columns
            lC.push({
              fields: x.fields,
              label: this.mapdata.Dialers[I1].header[I2].label,
              headermap: cH
            })

            // pushing data for mapped data with header
            mD.push({
              crmfields: this.mapdata.Dialers[I1].header[I2].crmfields,
              headermap: cH,
              label: this.mapdata.Dialers[I1].header[I2].label
            })
          } else {
            // pushing data for lead columns
            lC.push({
              fields: x.fields,
              label: x.label,
              headermap: 0
            })
          }
        } else {
          // pushing data for lead columns
          lC.push({
            fields: x.fields,
            label: x.label,
            headermap: 0
          })
        }
      }
      // pushing final data into lead columns
      this.ledsColumn.Dialers.push({
        id_dialer: x1.id_dialer,
        dialer: dT,
        header: lC
      })

      // pushing final data into mapped header
      this.mappeddata.Dialers.push({
        id_dialer: x1.id_dialer,
        header: mD
      })
    }

    console.log("this.mappeddata::2", this.mappeddata)
  }
  // This method will set label with header fields
  setHeaderOption(column: string, fileheader: any, label: string, type: number, id_dialer: number = 0) {
    console.log("column:", column)
    console.log("fileheader:", fileheader)

    // for raw header mapping
    if (type == 1)
      for (let x of this.ledsColumn.RawHeader) {
        if (x.fields == column) {
          let I1: any = this.mappeddata.RawHeader.findIndex((ele: any) => {
            return ele.crmfields == column
          })
          if (I1 > -1)
            this.mappeddata.RawHeader.splice(I1, 1)

          if (fileheader != -1) {
            let csv_label = this._fileheader[fileheader - 1]
            this.mappeddata.RawHeader.push({
              crmfields: column,
              headermap: fileheader,
              label: csv_label
            })
          }
        }
      }

    // for dialer-wise header mapping
    if (type == 2) {
      // It will find index of current dialer
      let Index: any = this.ledsColumn.Dialers.findIndex((ele: any) => {
        return ele.id_dialer == id_dialer
      })

      if (Index > -1) {

        for (let x of this.ledsColumn.Dialers[Index].header) {
          if (x.fields == column) {
            // It will find the Index position of each dialer
            let I1: any = this.mappeddata.Dialers.findIndex((ele: any, i: any) => {
              return ele.id_dialer == id_dialer
            })

            if (I1 > -1) {
              let I2: any = this.mappeddata.Dialers[I1].header.findIndex((ele: any, i: any) => {
                return ele.crmfields == column
              })
              if (I2 > -1)
                this.mappeddata.Dialers[I1].header.splice(I2, 1)

              if (fileheader != -1) {
                let csv_label = this._fileheader[fileheader - 1]

                // pushing data into header mapped data
                this.mappeddata.Dialers[I1].header.push({
                  crmfields: column,
                  headermap: fileheader,
                  label: csv_label
                })
              }
            } else {
              if (fileheader != -1) {
                let csv_label = this._fileheader[fileheader - 1]
                this.mappeddata.Dialers.push({
                  id_dialer: id_dialer,
                  header: [
                    {
                      crmfields: column,
                      headermap: fileheader,
                      label: csv_label
                    }
                  ]
                })
              }
            }
          }
        }
      }
    }

  }

  ChangeTemplate(event: any) {
    let id_template = event.value
    console.log("Template changed::", id_template)

    // It will reset form fields before loading the template
    this.ledsColumn = {
      RawHeader: [],
      Dialers: []
    }

    this.mappeddata = {
      RawHeader: [],
      Dialers: []
    }

    if (id_template > 0) {
      let tempName = this.alltemplate.find(((item: any) => {
        return item.id == id_template
      }))
      this.template_name = tempName.name

      let Index: any = this.data.maphead.findIndex((ele: any) => {
        return ele.id == id_template
      })
      if (Index > -1)
        this.mapdata = this.data.maphead[Index].field_map
      else
        this.mapdata = {
          RawHeader: [],
          Dialers: []
        }
    } else {
      this.mapdata = {
        RawHeader: [],
        Dialers: []
      }
      this.template_name = '';

      
    }

console.log("mapdata:::::",this.mapdata)
    // @It will load current template into field's columns
    this.ldTmp()
  }

  mapClose(sdata: any) {
    this.dialogRef.close(sdata);
    console.log(sdata);
  }

  svMapping(type: number = 0): void {
    let iSv: boolean = type ? true : false

    // setting json to post this data to server
    // to lead upload with header mappin
    if (this.mappeddata.RawHeader.length > 0) {
      this.mapClose(JSON.stringify({
        mapping_header: this.mappeddata.RawHeader,
        dialers: this.mappeddata.Dialers,
        filepath: this.data.filepath,
        headerlen: this.leadHeader.length,
        saveheader: iSv,
        id_upload: this.data.id_upload,
        template_name: this.template_name,
        template_id: this.template_id,
        isC: true
      }))
    } else {
      alert("No Fields Mapped. Please map fields to upload leads.")
    }
  }

  Close() {
    this.dialogRef.close(JSON.stringify({
      isC: false
    }));
    console.log("close");
  }

}
